import { render, staticRenderFns } from "./partnerBankInfo.vue?vue&type=template&id=031f6e4c"
import script from "./partnerBankInfo.vue?vue&type=script&lang=js"
export * from "./partnerBankInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports